import { environment } from 'environments/environment';
import { Component, OnInit } from '@angular/core';
import { AcessoRestritoSiteService } from 'app/services/acesso-restrito.service';
import { finalize } from 'rxjs/operators';
import { MensagensService } from '../services/mensagens.service';

@Component({
  selector: 'app-sub-menu-relatorios',
  templateUrl: './sub-menu-relatorios.component.html',
  styleUrls: ['./sub-menu-relatorios.component.css']
})
export class SubMenuRelatoriosComponent implements OnInit {

  componente = '';
  prestadores = '';
  organograma = '';
  featuresContent = [
    // {
    //   'image_path': './assets/img/dash_resolucao.png',
    //   'heading': 'Resolução CNPC Nº 32 – RDI',
    //   'url': 'RESOLUCAO'
    // },
    {
      'image_path': './assets/img/dash_grafico.png',
      'heading': 'Relatórios',
      'url': 'RELATORIOS'
    },
    {
      'image_path': './assets/img/dash_atas.png',
      'heading': 'Extrato das atas das reuniões',
      'url': 'ATAS'
    },
    {
      'image_path': './assets/img/dash_prestadores.png',
      'heading': 'Prestadores de serviços',
      'url': 'PRESTADORES'
    },
    // {
    //   'image_path': './assets/img/dash_resolucao.png',
    //   'heading': 'Composição órgãos estatutários',
    //   'url': 'ORGANOGRAMA'
    // },
  ];

  constructor(public acessoRestritoSiteService: AcessoRestritoSiteService, public mensagensService: MensagensService) {
    this.prestadores = environment.pdfPrestadores;
    this.organograma = environment.pdfOrganograma;
  }

  ngOnInit(): void {
    this.obter();
  }

  obter() {
    this.acessoRestritoSiteService.composicaoestatutaria()
      .pipe(finalize(() => {
      }))
      .subscribe(result => {
        this.organograma = result?.composicao?.url;
        this.prestadores = result?.prestador?.url;
      },
        err => {
        });
  }

  menu(item: string): void {
    if (item === 'PRESTADORES') {
       window.open(this.prestadores, '_blank')
      // this.mensagensService.openBase64FileInNewTab(this.prestadores, "prestadores_derminas.pdf");
    } else if (item === 'ORGANOGRAMA') {
      window.open(this.prestadores, '_blank')
      //this.mensagensService.openBase64FileInNewTab(this.organograma, "organograma_derminas.pdf");
    } else {
      this.componente = item;
    }
  }


}
